import { render, staticRenderFns } from "./RegisterСlient.vue?vue&type=template&id=432ba856&scoped=true&"
import script from "./RegisterСlient.vue?vue&type=script&lang=js&"
export * from "./RegisterСlient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432ba856",
  null
  
)

export default component.exports